var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import autoBind from "auto-bind";
import { PopoverContainer, PopoverWrapper } from "./style";

var Popover = function (_PureComponent) {
  _inherits(Popover, _PureComponent);

  function Popover(props) {
    _classCallCheck(this, Popover);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.state = {
      isOpen: false
    };
    autoBind(_this);
    return _this;
  }

  Popover.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({ isOpen: false });
  };

  Popover.prototype.getPopoverEvents = function getPopoverEvents(returnEvents) {
    var _this2 = this,
        _ref2;

    var _props = this.props,
        openEvent = _props.openEvent,
        closeEvent = _props.closeEvent;


    if (!returnEvents) return {};

    if (openEvent === closeEvent) {
      var _ref;

      return _ref = {}, _ref[openEvent] = function () {
        return _this2.toggle();
      }, _ref;
    }
    return _ref2 = {}, _ref2[openEvent] = function () {
      return _this2.open();
    }, _ref2[closeEvent] = function () {
      return _this2.close();
    }, _ref2;
  };

  Popover.prototype.toggle = function toggle() {
    this.setState(function (prevState) {
      return { isOpen: !prevState.isOpen };
    });
  };

  Popover.prototype.open = function open() {
    this.setState({ isOpen: true });
  };

  Popover.prototype.close = function close() {
    this.setState({ isOpen: false });
  };

  Popover.prototype.render = function render() {
    var _props2 = this.props,
        title = _props2.title,
        children = _props2.children,
        triggerComponent = _props2.triggerComponent,
        eventsTriggerOnly = _props2.eventsTriggerOnly,
        props = _objectWithoutProperties(_props2, ["title", "children", "triggerComponent", "eventsTriggerOnly"]);

    var isOpen = this.state.isOpen;


    return React.createElement(
      PopoverWrapper,
      _extends({}, this.getPopoverEvents(!eventsTriggerOnly), {
        "data-test": "component-popover"
      }),
      triggerComponent(_extends({
        "data-test": "component-popover-trigger"
      }, this.getPopoverEvents(eventsTriggerOnly))),
      isOpen && React.createElement(
        PopoverContainer,
        _extends({}, props, { "data-test": "component-popover-content" }),
        title,
        children(this.close)
      )
    );
  };

  return Popover;
}(PureComponent);

Popover.defaultProps = {
  title: null,
  placement: "top",
  openEvent: "onMouseEnter",
  closeEvent: "onMouseLeave",
  eventsTriggerOnly: false
};

Popover.propTypes = {
  /** Title of the popover. Could be a string or a react node. */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Content of the popover. Should be a function that receives a function to close the popover as argument and returns a react node. */
  children: PropTypes.func.isRequired,
  /** Render prop that will be used to trigger the popover's opening and closing actions. */
  triggerComponent: PropTypes.func.isRequired,
  /** Placemente of the popover. Use bottom, left, right, or top values */
  placement: PropTypes.oneOf(["bottom", "bottomStart", "bottomEnd", "left", "leftStart", "leftEnd", "right", "rightStart", "rightEnd", "top", "topStart", "topEnd"]),
  /** Event to trigger the popover's opening action */
  openEvent: PropTypes.string,
  /** Event to trigger the popover's closing action */
  closeEvent: PropTypes.string,
  /** Indicates that the events will be triggered only by the trigger component */
  eventsTriggerOnly: PropTypes.bool
};

export default Popover;